import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Home from '../../layouts/Home/Home';
import Login from '../user/login/Login';
import ChangePassword from '../user/ChangePassword';
import Register from '../user/register/Register';
import { reactLocalStorage } from 'reactjs-localstorage';
import jwt from 'jsonwebtoken';
import { User } from '../../type/entity';

export default function App() {
  const pathNotLogin = ['/register', '/login', '/change-password'];

  function handleTokenInvalid() {
    reactLocalStorage.remove('user.info');
    window.location.href = '/login';
  }

  if (!pathNotLogin.includes(window.location.pathname)) {
    const user = reactLocalStorage.getObject('user.info') as User;

    if (!user) {
      handleTokenInvalid();
    }

    const token = user.user_acc_tokn;

    if (!token) {
      handleTokenInvalid();
    }

    const expiry = jwt.decode(token, { json: true })?.exp;
    const now = new Date();

    if (expiry && now.getTime() > expiry * 1000) {
      handleTokenInvalid();
    }
  }

  return (
    <BrowserRouter>
      <Switch>
        <Route path="/register" component={Register} />
        <Route path="/login" component={Login} />
        <Route path="/change-password" component={ChangePassword} />
        <Route path="/" component={Home} />
      </Switch>
    </BrowserRouter>
  );
}
